export function setCookie(cName, cValue, eMinutes, cPath, cDomain) {
  var D = new Date();
  var expires;
  var domain;
  var path;

  try {
    D.setTime(D.getTime() + eMinutes * 60 * 1000); // TODO: test session cookie
    expires = ';expires=' + D.toUTCString();
    domain = ';domain=.' + (cDomain || window.location.hostname);
    path = ';path=' + (cPath || '/');

    document.cookie = cName + '=' + cValue + expires + domain + path;
  } catch (ignore) {
    //
    console.log(ignore);
  }
}
